module.exports = __webpack_public_path__ + "img/place.758b98f2.gif";